import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { singleNotification } from '../../service/api/notification/singleNotificationDetails';
import { deleteNotification } from '../../service/api/notification/deleteNotification';
import AcceptRejectModal from '../../jsx/components/modalAcceptReject/modalAcceptreject';
import './particularNotificationDetails.scss'
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { txtServiceRequestDetails } from '../../dataBaseFile/label';
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import ImagePreviewer from '../../jsx/components/imagePreviewer/imagePreviewer';

const ParticularNotificationDetails = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [time, setTime] = useState(0)
    const [message, setMessage] = useState('')
    const [link, setLink] = useState('')
    const [open, setOpen] = useState(false)
    const [activeStatus, setActiveStatus] = useState(0)
    const [notificationType, setNotificationType] = useState();
    const [ticketID, setTicketID] = useState();
    const [acceptOrRejectTicket, setAcceptOrRejectTicket] = useState();
    const [metaDataChr, setMetaDataChr] = useState("");
    const [attachmentUrl, setAttachmentUrl] = useState("");

    const [basicModal, setBasicModal] = useState(false);

    const [imageAttachURL, setImageAttachURL] = useState('');
    const [openDoc, setOpenDoc] = React.useState(false);
    const [notificationDetailsLoading, setNotificationDetailsLoading] = useState(false);


    const handleOpenDoc = (docType) => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);

    const tooltip = (
        <Tooltip id="tooltip" >
            <strong >Delete</strong>
        </Tooltip>
    );

    useEffect(() => {
        particularNotificationDetails()
    }, [localStorage.getItem('notifcation_id')])

    const particularNotificationDetails = () => {
        setNotificationDetailsLoading(true);
        let details = {
            user_id_ids: localStorage.getItem('user_id'),
            notification_id_ids: localStorage.getItem('notifcation_id'),
        }
        dispatch(
            singleNotification(details, (e) => {
                setNotificationDetailsLoading(false);
                setTime(e.data.data.created_date_dtm + '000');
                setMessage(e.data.data.message_chr);
                setLink(e.data.data.link_chr);
                setActiveStatus(e.data.data.status_ysn);
                setNotificationType(e.data.data.notification_type_int);
                localStorage.setItem("roomCode", e.data.data.room_id);
                setTicketID(e.data.data.ticket_id_ids);
                setMetaDataChr(e.data.data.meta_data_chr);
                setAttachmentUrl(e.data.data.notification_image_path_chr);
            }, () => { 
                setNotificationDetailsLoading(false);
            }),
        )
    }

    const deleteSingleDetails = (e) => {
        let details = {
            user_id_ids: localStorage.getItem('user_id'),
            notification_id_ids: localStorage.getItem('notifcation_id'),
        }
        dispatch(
            deleteNotification(details, (res) => {
                setOpen(false)
                navigate('/notificationPage')
            }),
        )
    }

    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }


    const handleJoin = () => {
        // navigate("/videoCall")
        navigate("/videoCall")
        // window.open(process.env.REACT_APP_VIDEO_URL)
    }

    //  Redirect to particular ticket details 
    function particularTicketDetailsFn() {

        localStorage.setItem("ticket_id", ticketID)
        navigate("/serviceRequestDetails")

        // let details = new FormData();
        // details.append("meta_data", metaDataChr);
        // details.append("accept_reject_flag", flag)

        // dispatch(
        //   acceptRejectRequest(
        //     details, ()=>{},()=>{}
        //   )
        // )

        // if(flag == 1){
        //   navigate("/particularTicketDetails")
        // }

    }

    const backToPrevious = () => {
        navigate(-1)
    }
    return (
        <>
            <Card
                className='bg-white'
                style={{ marginBottom: '10px', height: 'auto' }}
            >
                <Card.Header>
                    <Card.Title>
                        <h4 onClick={backToPrevious} className='back-to-admin-btn'>
                            <i style={{ marginRight: '10px', }} className="bi bi-arrow-left "></i>
                            {"Notification Details"}
                        </h4>


                    </Card.Title>
                </Card.Header>
                <Card.Body className='particular-notification-body'>
                    <div className='notification-detail-main-container'>
                        <div className='particular-notification-delete'>
                            <OverlayTrigger placement="top" overlay={tooltip}>
                                <div onClick={() => {
                                    setBasicModal(true)
                                }} className="d-flex align-items-center justify-content-center" style={{ color: '#F65160', fontSize: '22px', cursor: 'pointer' }}>
                                    <i class="bi bi-trash"></i>
                                </div>
                            </OverlayTrigger>
                        </div>

                        <div className='particular-notification-content-main-container'>

                            <div className='particular-notification-content'>
                                <div className="particular-notification-title">
                                    <p style={{ marginBottom: '0px' }}>Message</p>
                                </div>

                                <div className='particular-notification-dash'>-</div>

                                <div className='particular-notification-txt'>
                                    {notificationDetailsLoading ? <SkeletonDivElement height={'30px'} /> : <p style={{ marginBottom: '0px' }}>{message}</p>}
                                </div>
                            </div>

                            <div className='particular-notification-content'>
                                <div className="particular-notification-title">
                                    <p style={{ marginBottom: '0px' }}>Created date</p>
                                </div>

                                <div className='particular-notification-dash'>-</div>

                                <div className='particular-notification-txt'>
                                    {notificationDetailsLoading ? <SkeletonDivElement height={'30px'} /> :
                                        <p style={{ marginBottom: '0px' }}>
                                            {new Intl.DateTimeFormat('en-US', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                            }).format(time)}
                                        </p>}

                                </div>
                            </div>

                            {attachmentUrl && <div className='particular-notification-content'>
                                <div className="particular-notification-title">
                                    <p style={{ marginBottom: '0px' }}>Attachment</p>
                                </div>

                                <div className='particular-notification-dash'>-</div>

                                <div className='particular-notification-txt'>
                                    {notificationDetailsLoading ?
                                        <SkeletonDivElement height={'150px'} width={'200px'} /> :
                                        <div>
                                            {/* <img className='rounded-2' src={attachmentUrl} alt="attachment" width={'100px'} height={'150px'} /> */}

                                            <div
                                                className='align-items-center d-flex justify-content-center rounded-3 border text-black me-3 overflow-hidden bg-black'
                                                style={{ width: '200px', height: '150px' }}
                                            >
                                                {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                <img
                                                    onClick={() => {
                                                        handleOpenDoc(); setImageAttachURL(attachmentUrl);
                                                    }}
                                                    className='documents-individual-box-img rounded-3 w-100 h-100'
                                                    src={attachmentUrl}
                                                    alt=''
                                                    style={{ objectFit: 'contain' }}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>}



                            <div>

                                {
                                    activeStatus === 1 && notificationType === 0 &&
                                    <div className='mb-2'>
                                        <PrimaryButton
                                            buttonName={'Join Call'}
                                            onClick={handleJoin}
                                            style={{
                                                width: '220px',
                                                border: "none",
                                                background: "linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)",
                                                boxShadow: "rgba(45, 204, 99, 0.24) 0px 6px 12px 0px"
                                            }}
                                        />
                                    </div>
                                }

                                {/* {notificationType === 1 && <PrimaryButton buttonName={'Check Waiting List'} onClick={() => { navigate('/waitingUserDashboard') }} />} */}

                                {notificationType === 2 &&
                                    <div>
                                        <PrimaryButton
                                            buttonName={`SERVICE DETAILS`}
                                            onClick={() => { particularTicketDetailsFn() }}
                                            style={{
                                                width: '220px',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                            }}
                                        />
                                    </div>
                                }
                            </div>
                        </div>

                    </div>

                </Card.Body>
            </Card>

            <AcceptRejectModal text={"Are you sure you want to delete notification ?"}
                onClickReject={() => {
                    setBasicModal(false);
                }}
                onClickAccept={() => { deleteSingleDetails() }}
                modalStatus={basicModal}
            />

            {/* Image previewer */}
            {openDoc &&
                <ImagePreviewer
                    openDoc={openDoc}
                    handleCloseDoc={handleCloseDoc}
                    imageAttachURL={imageAttachURL}
                />
            }
        </>
    )
}

export default ParticularNotificationDetails